import { FunctionComponent, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

import { NoCallsImage } from '../../../assets';

export const NoCallsCard: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => {
  return (
    <div className={twMerge('', className)} {...props}>
      <img src={NoCallsImage} alt="No calls here yet" />
      <p className="text-dark font-manrope mt-6 text-center text-lg font-bold">No calls here yet</p>
    </div>
  );
};
